export const BASE_SIZE_PX = 8;
export const BASE_FONT_SIZE_PX = BASE_SIZE_PX * 2;
